export function DocsSpatialPage() {
  return (
    <div className="docs-article">
      <p className="docs-eyebrow">Realtime</p>
      <div className="docs-title-row">
        <h1 className="docs-page-title">Spatial Subspaces</h1>
        <span className="badge badge--ok docs-page-status">Online</span>
      </div>
      <p className="docs-lede">
        Managed Spatial Subspaces route opaque realtime state by 3D position and interest inside
        server-controlled AABB bounds.
      </p>

      <div className="panel notice-panel docs-spatial-notice">
        <p className="page-prose">
          Each managed server keeps logical compatibility spaces <code>1</code> and <code>2</code>
          and can add up to 64 user-configured <code>SpatialGrid3D</code> spaces. Logical spaces do
          not count toward that limit. Host allocates spatial numeric IDs from <code>3</code>.
        </p>
      </div>

      <h2 className="docs-heading">Add-only managed definitions</h2>
      <p className="docs-body">
        Add a Spatial Subspace from the server Details page with a stable lowercase slug and a
        display name, each 1–64 characters. Definitions are immutable for the server generation. An
        exact retry is idempotent; reusing a slug with another name or definition is rejected.
        Unknown, wildcard, and ad-hoc spaces are not granted or returned to clients.
      </p>
      <dl className="detail-list">
        <div className="detail-row">
          <dt>Dimensions</dt>
          <dd>Three-dimensional Cartesian routing only.</dd>
        </div>
        <div className="detail-row">
          <dt>Scale</dt>
          <dd>
            <code>metersPerUnit: 1</code>
          </dd>
        </div>
        <div className="detail-row">
          <dt>Grid and interest</dt>
          <dd>
            <code>cellSize: 10</code>, <code>interestRadius: 25</code>, and
            <code> exactDistance: true</code>
          </dd>
        </div>
        <div className="detail-row">
          <dt>Default bounds</dt>
          <dd>
            Min <code>(-1000, -100, -1000)</code>; max <code>(1000, 500, 1000)</code>. Every minimum
            axis must be strictly less than its maximum.
          </dd>
        </div>
      </dl>

      <h2 className="docs-heading">Connection and routing contract</h2>
      <p className="docs-body">
        Connection and monitoring data expose the two logical spaces followed by complete managed
        spatial definitions, including numeric ID, bounds, scale, cell size, interest radius, and
        exact-distance policy. Rust QUIC and TypeScript WebTransport clients must use those returned
        definitions rather than inventing IDs or overriding server policy.
      </p>
      <p className="docs-body">
        Managed spatial routing is Online. Channel <code>1</code> is
        <code> ReliableOrdered</code>; channel <code>4</code> is
        <code> UnreliableSequenced</code>. Both remain Ephemeral and carry opaque bytes. Persistence
        beyond Ephemeral and Inference remain Preview.
      </p>
    </div>
  );
}
